import React, { useEffect, useState, useMemo } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Button,
  Grid,
  IconButton,
  TextareaAutosize,
  Typography,
  Popover,
} from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomButton from "../../Components/CustomButton";
import CustomSelect from "../../Components/CustomSelect";
import CustomInput from "../../Components/CustomInput";
import PurchaseOrder from "../../Components/Simple Purchase/PurchaseOrder";
import ModalForms from "../../Components/Simple Purchase/ModalForms";
import CustomSnackbar from "../../Components/CustomSnackbar";
import CircularLoader from "../../Components/shared/CircularLoader/CircularLoader";
import { toast } from "react-toastify";
import {
  createNewContact,
  fetchSearchedContacts,
} from "../../redux/slices/contactSlice";
import {
  getSuppliers,
  createNewSupplier,
} from "../../redux/slices/supplierSlice";
import {
  getCurrencies,
  getPaymentTerms,
  getStatus,
  getDefaultCarrier,
  getTaxRule,
  getAllEntities,
} from "../../redux/slices/entitySlice";
import { connect } from "react-redux";
import { useSelector } from "react-redux";
import { debounce } from "lodash";
import { Api } from "../../Config/request";
import { parse } from "date-fns";
import { updatePurchaseOrder } from "../../service/productApi";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { useDispatch } from "react-redux";

const AddPurchase = ({
  createContact,
  getSupplierList,
  createSupplier,
  getCurrencies,
  getStatus,
  getPaymentTerms,
  getDefaultCarrier,
  getTaxRule,
  fetchSearchedContacts,
  getAllEntities
}) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const { orderDetails, mode = "ADD" } = location.state || {}; 
  const purchaseOrderItem = orderDetails?.[0];

  const [open, setOpen] = useState(true);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [paymentTermsOptions, setPaymentTermsOptions] = useState([]);
  const [defaultCarrierOptions, setDefaultCarrierOptions] = useState([]);
  const [taxRuleOptions, setTaxRuleOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    supplier: "",
    contact: "",
    phone: "",
    supplierAddress1: "",
    supplierAddress2: "",
    location: "",
    terms: "",
    taxRule: "",
    required_by: "",
    comments: "",
    order_date: "",
    delivery_date: "",
    status: "",
    currency: "",
  });

  // -----------  ADD  ----------
  const [contactOptions, setContactOptions] = useState([]);
  const [addressOptions, setAddressOptions] = useState([]);
  const [supplierOptions, setSupplierOptions] = useState([]);

  // -----------  VIEW  ----------
  const [products, setProducts] = useState([]);
  const [additionalCosts, setAdditionalCosts] = useState([]);

  // -----------  EDIT  ----------
  const [supplierProducts, setSupplierProducts] = useState([]);

  // -----------  COMMON  ----------
  const [supplierData, setSupplierData] = useState([]);
  const [fetchedAddresses, setFetchedAddresses] = useState([]);
  const [data, setData] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [contactInputTyped, setContactInputTyped] = useState(false);
  const openPopover = Boolean(anchorEl);
  const isSupplierSelected = !!formData?.supplier;

  const supplierDisplayValue = useMemo(() => {
    const selectedSupplier = supplierData.find(
      (s) => s.id === formData.supplier
    );
    // Return the name if found, otherwise return the ID itself (or an empty string)
    // This helps during initial load before the name is resolved.
    return selectedSupplier ? selectedSupplier.name : formData.supplier || "";
  }, [formData.supplier, supplierData]);

  const selectedSupplier = useMemo(() => {
    if (!formData.supplier || supplierData.length === 0) {
      return null;
    }
    return supplierData.find((s) => s.id === formData.supplier);
  }, [formData.supplier, supplierData]);

  const [openModal, setOpenModal] = useState({
    newSupplier: false,
    newContact: false,
    newPaymentTerm: false,
    newLocation: false,
    newCompanyAddress: false,
    newSupplierAddress: false,
    newShippingAddress: false,
  });
  // ----------------------------------      ADD NEW PURCHASE ORDER   ------------------------------------------

  const { suppliersListLoading, supplierLoading } = useSelector((state) => state.supplier);

  const { contactListLoading, contactLoading, contactList } = useSelector((state) => state.contact);

  const {entities, error, entitiesLoading} = useSelector((state) => state.entity);

  console.log("All entities are coming here ---------->>", entities);

  const {currencies, error: currenciesError, isLoading: entityLoading} = useSelector((state) => state.entity);
  const { status, error: statusError } = useSelector((state) => state.entity);
  const { paymentTerms, error: paymentTermsError } = useSelector((state) => state.entity);
  const { defaultCarrier, error: defaultCarrierError } = useSelector((state) => state.entity);
  const { taxRule, error: taxRuleError } = useSelector((state) => state.entity);

  // Additional loading states for products and addresses
  const { productListLoading, productLoading, productsListLoading } =
    useSelector((state) => state.products);
  const { addressListLoading, addressLoading } = useSelector(
    (state) => state.address
  );

  const handleChange = (e, nameOverride, valueOverride) => {
    let name = nameOverride || e.target?.name;
    let value = valueOverride ?? e.target?.value;

    if (
      name === "required_by" ||
      name === "order_date" ||
      name === "delivery_date"
    ) {
      // Handle date picker change
      value = value ? dayjs(value).format("YYYY-MM-DD") : "";
      setFormData((prev) => ({ ...prev, [name]: value }));
    } else if (name === "supplier") {
      const selectedSupplier = supplierData.find((s) => s.name === value);
      setFormData((prev) => ({
        ...prev,
        // When a supplier is selected by name, store its ID.
        // Clear dependent fields to ensure data consistency.
        supplier: selectedSupplier ? selectedSupplier.id : value,
        contact: "",
        phone: "",
        supplierAddress1: "",
        supplierAddress2: "",
        terms: selectedSupplier ? selectedSupplier.payment_terms || "" : "",
      }));
    } else {
      // For other fields, just update the value
      console.log("name of this field if status or currency --------->", name);
      setFormData((prev) => ({
        ...prev,
        [name]: value ?? "",
      }));
    }
  };

  const checkboxChange = (event) => {
    const { name, type, value, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleAddClick = (label) => {
    if (
      label !== "Supplier" &&
      (!formData.supplier || formData.supplier === "Select")
    ) {
      toast.warn("You need to select a supplier first");
      return;
    } else {
      switch (label) {
        case "Supplier":
          setOpenModal({ newSupplier: true });
          setData([
            {
              key: "name",
              label: "Name",
              type: "text",
              placeholder: "Enter supplier name",
              width: { xs: "100%", md: "49%" },
              required: true,
            },
            {
              key: "supplierStatus",
              label: "Status",
              type: "select",
              placeholder: "Select...",
              width: { xs: "100%", md: "49%" },
              required: true,
              data: statusOptions,
            },
            {
              key: "currency",
              label: "Currency",
              type: "select",
              placeholder: "Select...",
              width: { xs: "100%", md: "49%" },
              required: true,
              data: currencyOptions,
            },
            {
              key: "paymentTerm",
              label: "Payment Term",
              type: "select",
              placeholder: "Select...",
              width: { xs: "100%", md: "49%" },
              required: true,
              data: paymentTermsOptions,
            },
            {
              key: "taxRule",
              label: "Tax Rule",
              type: "select",
              placeholder: "Select...",
              width: { xs: "100%", md: "49%" },
              required: true,
              data: taxRuleOptions,
            },
            {
              key: "defaultCarrier",
              label: "Default Carrier",
              type: "select",
              placeholder: "Select...",
              width: { xs: "100%", md: "49%" },
              required: false,
              data: defaultCarrierOptions,
            },
            {
              key: "discount",
              label: "Discount",
              type: "number",
              placeholder: "Enter Discount",
              width: { xs: "100%", md: "49%" },
              required: false,
            },
            {
              key: "taxNumber",
              label: "Tax Number",
              type: "text",
              placeholder: "Enter tax number",
              width: { xs: "100%", md: "49%" },
              required: false,
            }, // Changed to type: "text"
            {
              key: "fax",
              label: "Fax",
              type: "text",
              placeholder: "Enter fax",
              width: { xs: "100%", md: "49%" },
              required: false,
            }, // Added fax
            {
              key: "website",
              label: "Website",
              type: "text",
              placeholder: "Enter website",
              width: { xs: "100%", md: "49%" },
              required: false,
            }, // Added website
            {
              key: "comments",
              label: "Comments",
              type: "textField",
              placeholder: "Enter comments",
              width: "100%",
              required: false,
            },
          ]);
          break;
        case "Contacts":
          setOpenModal({ newContact: true });
          setData([
            {
              key: "firstName",
              label: "First Name",
              type: "text",
              placeholder: "Enter name",
              width: { xs: "100%", md: "49%" },
              required: true,
            },
            {
              key: "lastName",
              label: "Last Name",
              type: "text",
              placeholder: "Enter name",
              width: { xs: "100%", md: "49%" },
              required: true,
            },
            {
              key: "jobTitle",
              label: "Job Title",
              type: "text",
              placeholder: "Enter job title",
              width: { xs: "100%", md: "49%" },
            },
            {
              key: "fax",
              label: "Fax",
              type: "text",
              placeholder: "Enter fax",
              width: { xs: "100%", md: "49%" },
            },
            {
              key: "phone",
              label: "Phone Number",
              type: "number",
              placeholder: "Enter phone",
              width: { xs: "100%", md: "49%" },
              minLength: 10,
              maxLength: 10,
            },
            {
              key: "email",
              label: "Email",
              type: "email",
              placeholder: "Enter email",
              width: { xs: "100%", md: "49%" },
            },
            {
              key: "website",
              label: "Website",
              type: "text",
              placeholder: "Enter website",
              width: { xs: "100%", md: "49%" },
            },
            {
              key: "defaultForType",
              label: "Default for type",
              type: "toggle",
              width: { xs: "100%", md: "49%" },
            },
            {
              key: "comments",
              label: "Comments",
              type: "textField",
              placeholder: "Enter comments",
              width: "100%",
            },
          ]);
          break;
        case "Terms":
          setOpenModal({ newPaymentTerm: true });
          setData([
            {
              key: "name",
              label: "Name",
              type: "text",
              placeholder: "Enter name",
              width: "100%",
              required: true,
            },
            {
              key: "methods",
              label: "Methods",
              type: "select",
              placeholder: "Enter Methods",
              width: "100%",
              required: true,
              data: [
                "Number of days",
                "Day of the next month",
                "Last day of the next month",
              ],
            },
            {
              key: "days",
              label: "Days",
              type: "number",
              placeholder: "Enter days",
              width: "100%",
              required: true,
            },
          ]);
          break;
        case "Location":
          setOpenModal({ newLocation: true });
          setData([
            {
              key: "location",
              label: "Location",
              type: "text",
              placeholder: "Enter Location",
              width: "100%",
              required: true,
            },
          ]);
          break;
        case "Supplier's Address Line 1":
          setOpenModal({ newSupplierAddress: true });
          setData([
            {
              key: "addressType",
              label: "",
              type: "select",
              placeholder: "Select",
              width: "100%",
            },
            {
              key: "line1",
              label: "Line 1",
              type: "text",
              placeholder: "Enter Line 1",
              width: "100%",
              required: true,
            },
            {
              key: "line2",
              label: "Line 2",
              type: "select",
              placeholder: "Enter Line 2",
              width: "100%",
            },
            {
              key: "citySuburb",
              label: "City/Suburb",
              type: "text",
              placeholder: "Enter City/Suburb",
              required: true,
              width: { xs: "100%", md: "49%" },
            },
            {
              key: "country",
              label: "Country",
              type: "text",
              placeholder: "Select",
              width: { xs: "100%", md: "49%" },
              required: true,
            },
            {
              key: "provinceState",
              label: "Province/State",
              type: "text",
              placeholder: "Enter Province/State",
              width: { xs: "100%", md: "49%" },
              required: true,
            },
            {
              key: "type",
              label: "Type",
              type: "select",
              placeholder: "Select",
              width: { xs: "100%", md: "49%" },
            },
            {
              key: "postalCode",
              label: "Postal code/ZIP",
              type: "text",
              placeholder: "Enter Postal code/ZIP*",
              width: { xs: "100%", md: "49%" },
              required: true,
            },
            {
              key: "defaultForType",
              label: "Default for type",
              type: "toggle",
              width: { xs: "100%", md: "49%" },
            },
            {
              key: "comments",
              label: "Comments",
              type: "text",
              placeholder: "Enter Comments",
              width: "100%",
            },
          ]);
          break;
        case "Shipping Address Line 1":
          setOpenModal({ newShippingAddress: true });
          setData([
            {
              key: "addressType",
              label: "",
              type: "select",
              placeholder: "Select",
              width: "100%",
            },
            {
              key: "line1",
              label: "Line 1",
              type: "text",
              placeholder: "Enter Line 1",
              width: "100%",
              required: true,
            },
            {
              key: "line2",
              label: "Line 2",
              type: "select",
              placeholder: "Enter Line 2",
              width: "100%",
            },
            {
              key: "citySuburb",
              label: "City/Suburb",
              type: "text",
              placeholder: "Enter City/Suburb",
              width: { xs: "100%", md: "49%" },
              required: true,
            },
            {
              key: "country",
              label: "Country",
              type: "text",
              placeholder: "Select",
              width: { xs: "100%", md: "49%" },
              required: true,
            },
            {
              key: "provinceState",
              label: "Province/State",
              type: "text",
              placeholder: "Enter Province/State",
              width: { xs: "100%", md: "49%" },
              required: true,
            },
            {
              key: "type",
              label: "Type",
              type: "select",
              placeholder: "Select",
              width: { xs: "100%", md: "49%" },
            },
            {
              key: "postalCode",
              label: "Postal code/ZIP",
              type: "text",
              placeholder: "Enter Postal code/ZIP*",
              width: { xs: "100%", md: "49%" },
              required: true,
            },
            {
              key: "defaultForType",
              label: "Default for type",
              type: "toggle",
              width: { xs: "100%", md: "49%" },
            },
            {
              key: "comments",
              label: "Comments",
              type: "text",
              placeholder: "Enter Comments",
              width: "100%",
            },
          ]);
          break;
        default:
          break;
      }
    }
  };

  const handleCreateSupplier = async (values) => {
    const data = {
      name: values?.name,
      status: values?.supplierStatus,
      currency: values?.currency,
      payment_terms: Number(values?.paymentTerm), // Convert to number
      tax_rule: values?.taxRule,
      default_carrier: values?.defaultCarrier,
      discount: Number(values?.discount) || 0, // Ensure discount is a number
      tax_number: values?.taxNumber,
      comments: values?.comments,
      fax: values?.fax,
      website: values?.website,
      contacts: values?.contacts || [],
      addresses: values?.addresses || [],
      type: values?.type || "Supplier",
    };
    const response = await createSupplier(data);
    if (createNewSupplier.fulfilled.match(response)) {
      toast.success("Supplier created successfully!");
      setOpenModal({ newSupplier: false });
    } else if (createNewSupplier.rejected.match(response)) {
      toast.error(
        `Failed to create supplier: ${
          response.payload?.message || "Unknown error"
        }`
      );
    }
  };

  const handleCreateContact = async (values) => {
    const data = {
      firstName: values?.firstName,
      lastName: values?.lastName || "",
      preferredName:
        values?.preferredName ||
        `${values?.firstName || ""} ${values?.lastName || ""}`,
      email: values?.email,
      phone: values?.phone,
      cell_phone: values?.fax || "", // if 'fax' is what you meant for cell
      job_title: values?.jobTitle || "", // correct casing
      organisation_notifications: values?.organisation_notifications ?? true,
      type: values?.type || "Supplier",
      organisations: values?.organisations || [],
    };

    const response = await createContact(data);
    if (createNewContact.fulfilled.match(response)) {
      setOpenModal({ newContact: false });
    }
  };

  // ----------------------------------      VIEW/EDIT PURCHASE ORDER   ------------------------------------------


  // ------------------------------------------      OTHERS/COMMON     ------------------------------------------------

  const handleAddNewProduct = (newProduct) => {
    // Add the new product to the list of available supplier products
    setIsLoading(true);
    const newSupplierProduct = {
      ...newProduct,
      product_name: newProduct.name, // Ensure product_name is available for the dropdown
    };
    setSupplierProducts((prev) => [...prev, newSupplierProduct]);

    // Add the new product to the current purchase order's items table
    setProducts((prev) => [
      ...prev,
      {
        ...newSupplierProduct,
        id: prev.length + 1,
      },
    ]);
    setIsLoading(false);
  };

  useEffect(() => {
    const fetchDetailsForSupplier = async () => {
      if (!formData?.supplier) {
        setSupplierProducts([]);
        setContactOptions([]);
        setAddressOptions([]);
        return;
      }

      const selectedSupplier = supplierData.find(
        (s) => s.id === formData.supplier
      );

      if (selectedSupplier) {
        setSupplierProducts(selectedSupplier.products || []);

        // Fetch contacts
        if (selectedSupplier.contacts?.[0]?.href) {
          try {
            const contactResponse = await Api.GetRequest(
              selectedSupplier.contacts[0].href
            );
            setContactOptions(contactResponse.data.data || []);
          } catch (e) {
            console.error("Failed to fetch contacts for supplier", e);
          }
        }

        // Fetch addresses
        if (selectedSupplier.addresses?.[0]?.href) {
          try {
            const addressResponse = await Api.GetRequest(
              selectedSupplier.addresses[0].href
            );
            const fetchedAddress = addressResponse.data.data || [];
            setAddressOptions(fetchedAddress);
            setFetchedAddresses(fetchedAddress);
          } catch (e) {
            console.error("Failed to fetch addresses for supplier", e);
          }
        }
      } else {
        setSupplierProducts([]);
        setContactOptions([]);
        setAddressOptions([]);
      }
    };

    fetchDetailsForSupplier();
  }, [formData?.supplier, supplierData, mode]);

  useEffect(() => {
    const populateFormForEditOrView = async () => {
      if ((mode === "VIEW" || mode === "EDIT") && purchaseOrderItem) {
        setIsLoading(true);
        try {
          const supplier = purchaseOrderItem.organisations?.[0];
          if (!supplier) throw new Error("Supplier information is missing.");

          // Set basic form data from purchaseOrderItem
          setFormData((prev) => ({
            ...prev,
            supplier: supplier.id || "",
            terms: supplier.payment_terms || "",
            taxRule: supplier.tax_rule || "",
            required_by: purchaseOrderItem.required_by
              ? dayjs(purchaseOrderItem.required_by).format("YYYY-MM-DD")
              : "",
            comments: purchaseOrderItem.notes || "",
          order_date: purchaseOrderItem.order_date ? dayjs(purchaseOrderItem.order_date).format("YYYY-MM-DD") : "",
          delivery_date: purchaseOrderItem.delivery_date ? dayjs(purchaseOrderItem.delivery_date).format("YYYY-MM-DD") : "",
          status: purchaseOrderItem.status || "",
          currency: purchaseOrderItem.currency || "",
          }));

          // Set products and additional costs from purchaseOrderItem
          setProducts(
            purchaseOrderItem.products?.map((p, i) => ({ ...p, id: i + 1 })) ||
              []
          );
          setAdditionalCosts(
            purchaseOrderItem.other_costs?.map((c, i) => ({
              ...c,
              id: i + 1,
            })) || []
          );

          // Since supplier is pre-filled, fetch its details
          const supplierDetailsFromList = supplierData.find(
            (s) => s.id === supplier.id
          );
          if (supplierDetailsFromList) {
            // Fetch contacts
            if (supplierDetailsFromList.contacts?.[0]?.href) {
              const contactResponse = await Api.GetRequest(
                supplierDetailsFromList.contacts[0].href
              );
              const fetchedContacts = contactResponse.data.data || [];
              setContactOptions(fetchedContacts);
              // Assuming the first contact is the selected one
              if (fetchedContacts.length > 0) {
                setFormData((prev) => ({
                  ...prev,
                  contact: fetchedContacts[0].preferredName,
                  phone: fetchedContacts[0].phone,
                }));
              }
            }
            // Fetch addresses
            if (supplierDetailsFromList.addresses?.[0]?.href) {
              const addressResponse = await Api.GetRequest(
                supplierDetailsFromList.addresses[0].href
              );
              const fetchedAddresses = addressResponse.data.data || [];
              setAddressOptions(fetchedAddresses);
              setFetchedAddresses(fetchedAddresses);
              // Assuming the first address is the selected one
              if (fetchedAddresses.length > 0) {
                setFormData((prev) => ({
                  ...prev,
                  supplierAddress1: fetchedAddresses[0].address_line_1,
                  supplierAddress2: fetchedAddresses[0].address_line_2,
                }));
              }
            }
          }
        } catch (error) {
          console.error("Failed to populate form for edit/view:", error);
          toast.error("Could not load purchase order details.");
        } finally {
          setIsLoading(false);
        }
      }
    };
    // We depend on supplierData being loaded before we can fetch contact/address details
    if (supplierData.length > 0) {
      populateFormForEditOrView();
    }
  }, [purchaseOrderItem, mode, supplierData]);

  const handleExpand = () => {
    setOpen(!open);
  };

  useEffect(() => {
    const debouncedSearch = debounce((searchTerm) => {
      if (typeof searchTerm === "string" && searchTerm.trim().length > 0) {
        fetchSearchedContacts({ firstName: searchTerm });
      }
    }, 300);

    // Cleanup function
    return () => {
      debouncedSearch.cancel();
    };
  }, [fetchSearchedContacts]);

  useEffect(() => {
    if (contactList?.data?.length) {
      setContactOptions(
        contactList.data.map((item) => {
          const firstName = item?.firstName || "";
          const lastName = item?.lastName || "";
          return `${firstName} ${lastName}`.trim();
        })
      );
    } else {
      setContactOptions([]);
    }
  }, [contactList]);

  useEffect(() => {
    if (!hasSearched) {
      setContactOptions([]);
      setContactInputTyped(false);
    }
  }, [hasSearched]);

  useEffect(() => {
    const fetchSuppliers = async () => {
      const response = await getSupplierList();
      const suppliers = response?.payload?.data || [];
      if (suppliers.length > 0) {
        setSupplierOptions(suppliers.map((item) => item.name));
        setSupplierData(suppliers);

        // If in VIEW/EDIT mode, now that we have supplier data, populate the form.
        if ((mode === "VIEW" || mode === "EDIT") && purchaseOrderItem) {
          populateForm(suppliers);
        }
      }
    };

    const populateForm = async (suppliers) => {
      setIsLoading(true);
      try {
        const supplier = purchaseOrderItem.organisations?.[0];
        if (!supplier) throw new Error("Supplier information is missing.");

        // Set basic form data from purchaseOrderItem
        setFormData((prev) => ({
          ...prev,
          supplier: supplier.id || "",
          terms: supplier.payment_terms || "",
          required_by: purchaseOrderItem.required_by
            ? dayjs(purchaseOrderItem.required_by).format("YYYY-MM-DD")
            : "",
          comments: purchaseOrderItem.notes || "",
        }));

        // Set products and additional costs
        setProducts(
          purchaseOrderItem.products?.map((p, i) => ({ ...p, id: i + 1 })) || []
        );
        setAdditionalCosts(
          purchaseOrderItem.other_costs?.map((c, i) => ({ ...c, id: i + 1 })) ||
            []
        );

        // Fetch related details for the pre-filled supplier
        // const supplierDetails = suppliers.find((s) => s.id === supplier.id);
        // if (supplierDetails) {
        //   if (supplierDetails.contacts?.[0]?.href) {
        //     const contactRes = await Api.GetRequest(
        //       supplierDetails.contacts[0].href
        //     );
        //     const contacts = contactRes.data.data || [];
        //     setContactOptions(contacts);
        //     if (contacts.length > 0) {
        //       setFormData((prev) => ({
        //         ...prev,
        //         contact: contacts[0].preferredName,
        //         phone: contacts[0].phone,
        //       }));
        //     }
        //   }
        // }
      } catch (error) {
        console.error("Failed to populate form for edit/view:", error);
        toast.error("Could not load purchase order details.");
      } finally {
        setIsLoading(false);
      }
    };

    fetchSuppliers();
  }, [getSupplierList, mode, purchaseOrderItem]);

  useEffect(() => {
    if (!currencies?.length) getCurrencies();
    if (!status?.length) getStatus();
    if (!paymentTerms?.length) getPaymentTerms();
    if (!defaultCarrier?.length) getDefaultCarrier();
    if (!taxRule?.length) getTaxRule();
    
    getAllEntities();
  }, [
    currencies,
    status,
    paymentTerms,
    defaultCarrier,
    taxRule,
    getCurrencies,
    getStatus,
    getPaymentTerms,
    getDefaultCarrier,
    getTaxRule,
    dispatch
  ]);

  useEffect(() => {
    if (currencies?.length) {
      setCurrencyOptions(currencies);
    }
    if (currenciesError) {
      toast.error(`Failed to load currencies: ${currenciesError}`);
    }
  }, [currencies, currenciesError]);

  useEffect(() => {
    if (status?.length) {
      setStatusOptions(status);
    }
    if (statusError) {
      toast.error(`Failed to load status: ${statusError}`);
    }
  }, [status, statusError]);

  useEffect(() => {
    if (paymentTerms?.length) {
      setPaymentTermsOptions(paymentTerms);
    }
    if (paymentTermsError) {
      toast.error(`Failed to load payment terms: ${paymentTermsError}`);
    }
  }, [paymentTerms, paymentTermsError]);

  useEffect(() => {
    if (defaultCarrier?.length) {
      setDefaultCarrierOptions(defaultCarrier);
    }
    if (defaultCarrierError) {
      toast.error(`Failed to load default carrier: ${defaultCarrierError}`);
    }
  }, [defaultCarrier, defaultCarrierError]);

  useEffect(() => {
    if (taxRule?.length) {
      setTaxRuleOptions(taxRule);
    }
    if (taxRuleError) {
      toast.error(`Failed to load tax rule: ${taxRuleError}`);
    }
  }, [taxRule, taxRuleError]);

  // useEffect to monitor all API loading states and display loader
  useEffect(() => {
    const anyLoading =
      suppliersListLoading ||
      supplierLoading ||
      contactListLoading ||
      contactLoading ||
      entityLoading ||
      productListLoading ||
      productsListLoading ||
      productLoading ||
      addressListLoading ||
      addressLoading;

    setIsLoading(anyLoading);
  }, [
    suppliersListLoading,
    supplierLoading,
    contactListLoading,
    contactLoading,
    entityLoading,
    productListLoading,
    productsListLoading,
    productLoading,
    addressListLoading,
    addressLoading,
  ]);

  return (
    <Box sx={{ paddingY: 1 }}>
      <CustomSnackbar />
      {isLoading && <CircularLoader />}
      <Box sx={{ mb: 2, bgcolor: "white", borderRadius: "10px" }}>
        <ModalForms
          open={openModal.newSupplier}
          data={data}
          setOpen={setOpenModal}
          name={"New Supplier"}
          handleSave={handleCreateSupplier}
          isLoading={supplierLoading}
        />
        <ModalForms
          open={openModal.newContact}
          data={data}
          setOpen={setOpenModal}
          name={"Add Supplier Contact"}
          handleSave={handleCreateContact}
          isLoading={contactLoading}
        />
        <ModalForms
          open={openModal.newSupplierAddress}
          data={data}
          setOpen={setOpenModal}
          name={"Add Supplier's Address"}
        />
        <ModalForms
          open={openModal.newPaymentTerm}
          data={data}
          setOpen={setOpenModal}
          name={"Add Payment Term"}
        />
        <ModalForms
          open={openModal.newLocation}
          data={data}
          setOpen={setOpenModal}
          name={"Add new Location"}
        />
        <ModalForms
          open={openModal.newShippingAddress}
          data={data}
          setOpen={setOpenModal}
          name={"Add Shipping Address"}
        />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #38535E",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Button
              variant="contained"
              sx={{
                bgcolor: "#FEE28A",
                color: "black",
                textTransform: "none",
                m: 2,
              }}
            >
              Draft
            </Button>
            <Typography sx={{ fontSize: "16px" }}>{mode === "ADD" ? "NEW" : mode === "EDIT" ? "EDIT" : "VIEW"} PURCHASE</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: 2,
                "@media (max-width: 900px)": { display: "none" },
              }}
            >
              <CustomButton
                text={"Save as a Template"}
                width={"25%"}
                border={"#95ABEB"}
                color={"#95ABEB"}
              />
              <CustomButton
                text={"Save a Template"}
                width={"25%"}
                border={"black"}
                color={"black"}
              />
              <CustomButton
                text={" Delete Template"}
                width={"25%"}
                border={"black"}
                color={"black"}
              />
            </Box>
            <IconButton
              onClick={handlePopoverOpen}
              sx={{
                "@media (min-width: 901px)": { display: "none" },
              }}
            >
              <MoreVertIcon />
            </IconButton>
            <IconButton onClick={handleExpand}>
              {open ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
            <Popover
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <Box
                sx={{ p: 2, display: "flex", flexDirection: "column", gap: 1 }}
              >
                <CustomButton
                  text={"Save as a Template"}
                  width={"100%"}
                  border={"#95ABEB"}
                  color={"#95ABEB"}
                />
                <CustomButton
                  text={"Save a Template"}
                  width={"100%"}
                  border={"black"}
                  color={"black"}
                />
                <CustomButton
                  text={" Delete Template"}
                  width={"100%"}
                  border={"black"}
                  color={"black"}
                />
              </Box>
            </Popover>
          </Box>
        </Box>
        {open && (
          <>
            <Grid container spacing={2} sx={{ p: 2 }}>
              <Grid item xs={12} md={4} rowGap={2}>
                <Typography variant="subtitle1">Supplier Details</Typography>
                <CustomSelect
                  label={"Supplier"}
                  name="supplier"
                  handleChange={handleChange}
                  handleAddClick={handleAddClick}
                  value={supplierDisplayValue}
                  add={true}
                  required={true}
                  searchable={true}
                  data={supplierOptions}
                  isLoading={suppliersListLoading}
                  disabled={mode === "VIEW" || mode === "EDIT"}
                />
                {/* <CustomSelect
                  label={"Contacts"}
                  name="contact"
                  handleAddClick={handleAddClick}
                  add={true}
                  required={true}
                  searchable={true}
                  value={formData?.contact}
                  handleChange={handleChange}
                  data={contactOptions.map((c) => c.preferredName)}
                  disabled={mode === "VIEW"}
                  isLoading={contactListLoading}
                  openDropdown={
                    contactInputTyped &&
                    hasSearched &&
                    Array.isArray(contactOptions) &&
                    contactOptions.length > 0
                  }
                />
                <CustomInput
                  label={"Phone"}
                  height={"40px"}
                  disabled={true} // Phone is auto-filled based on contact
                  value={formData?.phone}
                  handleChange={handleChange}
                  name="phone"
                />
                <CustomSelect
                  label={"Supplier's Address Line 1"}
                  name="supplierAddress1"
                  handleAddClick={handleAddClick}
                  add={true}
                  required={true}
                  handleChange={handleChange}
                  searchable={true}
                  value={formData?.supplierAddress1 || ""}
                  data={addressOptions.map((addr) => addr.address_line_1 || "")}
                  disabled={mode === "VIEW"}
                />
                <CustomInput
                  label={"Supplier's Address Line 2"}
                  height={"40px"}
                  value={formData?.supplierAddress2 || ""}
                  disabled={true} // Auto-filled based on Address Line 1
                /> */}
              </Grid>
              
              <Grid item xs={12} md={4}>
                <Typography variant="subtitle1">Accounting Details</Typography>
                <CustomInput
                  label={"Terms"}
                  name={"terms"}
                  value={formData?.terms || ""}
                  height={"40px"}
                  disabled={mode === "VIEW"}
                  handleChange={handleChange}
                />
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Required by"
                    value={formData.required_by ? dayjs(formData.required_by) : null}
                    onChange={(newValue) =>
                      handleChange(null, "required_by", newValue)
                    }
                    disabled={mode === "VIEW" ? true : false}
                    format="YYYY/MM/DD"
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        InputLabelProps: {
                          shrink: true,
                        },
                      },
                    }}
                    sx={{
                      width: "100%",
                      mt: 2,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        borderWidth: 2,
                      },
                    }}
                  />
                </LocalizationProvider>
                {/* <CustomInput
                  type="checkbox"
                  name="taxInclusive"
                  label="Tax Inclusive"
                  value={formData?.taxInclusive}
                  handleChange={checkboxChange}
                  disabled={mode === "VIEW"}
                />
                <CustomSelect
                  label={"Tax Rule"}
                  name={"taxRule"}
                  value={formData?.taxRule || ""}
                  data={taxRuleOptions}
                  disabled={mode === "VIEW"}
                  handleChange={handleChange}
                /> */}
              </Grid>

               <Grid item xs={12} md={4} rowGap={2}>
                <Typography variant="subtitle1">Order details</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Order Date"
                    value={formData.order_date ? dayjs(formData.order_date) : null}
                    onChange={(newValue) =>
                      handleChange(null, "order_date", newValue)
                    }
                    disabled={mode === "VIEW"}
                    format="YYYY/MM/DD"
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        InputLabelProps: { shrink: true },
                      },
                    }}
                    sx={{
                      width: "100%",
                      mt: 2,
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        borderWidth: 2,
                      },
                    }}
                  />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="Delivery Date"
                    value={formData.delivery_date ? dayjs(formData.delivery_date) : null}
                    onChange={(newValue) =>
                      handleChange(null, "delivery_date", newValue)
                    }
                    disabled={mode === "VIEW"}
                    format="YYYY/MM/DD"
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        InputLabelProps: { shrink: true },
                      },
                    }}
                    sx={{ width: "100%", mt: 2 }}
                  />
                </LocalizationProvider>

                <CustomSelect 
                label="Status" 
                name={"status"}
                value={formData?.status || ""} 
                handleChange={handleChange} 
                data={["Delivered", "Pending", "Shipped", "Cancelled", "Approved"]}
                disabled={mode === 'VIEW'} />

                <CustomSelect 
                label="Currency" 
                name={"currency"}
                value={formData?.currency || ""} 
                handleChange={handleChange} 
                data={["USD", "CAD"]}
                disabled={mode === 'VIEW'} />
              </Grid>
              {/* <Grid item xs={12} md={4}>
                <Typography variant="subtitle1">Shipping Details</Typography>
                <CustomInput
                  type="checkbox"
                  name="blindReceipt"
                  label="Blind Receipt"
                  value={formData.blindReceipt}
                  onChange={checkboxChange}
                  disabled={isViewMode}
                />
                <CustomInput
                  label={"Date"}
                  height={"40px"}
                  type="date"
                  disabled={isViewMode}
                />
                <CustomSelect
                  label={"Location"}
                  add={true}
                  handleAddClick={handleAddClick}
                  disabled={!isSupplierSelected || isViewMode}
                />
                <CustomInput
                  type="checkbox"
                  name="shipToDifferentCompany"
                  label={"Ship to different Company"}
                  value={formData.shipToDifferentCompany}
                  onChange={checkboxChange}
                  disabled={isViewMode}
                />
                <CustomSelect
                  label={"Shipping Address Line 1"}
                  add={true}
                  handleAddClick={handleAddClick}
                  data={addressOptions}
                  disabled={!isSupplierSelected || isViewMode}
                />
                <CustomInput
                  label={"Shipping Address Line 2"}
                  height={"40px"}
                  disabled={isViewMode}
                />
              </Grid> */}
            </Grid>

            <Box
              sx={{
                pt: 5,
                pr: 5,
                pb: 2,
                pl: 2,
                minWidth: "65%",
                maxWidth: "97%",
                borderRadius: "12px",
              }}
            >
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                NOTES <span style={{ color: "red" }}>*</span>
              </Typography>

              <TextareaAutosize
                placeholder="Write your notes here..."
                minRows={4}
                value={formData?.comments || ""}
                onChange={handleChange}
                name="comments"
                disabled={mode === "VIEW"}
                style={{
                  width: "100%",
                  padding: "12px",
                  fontSize: "16px",
                  borderRadius: "8px",
                  border:
                    mode === "VIEW" ? "1px solid #ccc" : "1px solid black",
                  resize: "vertical",
                  fontFamily: "inherit",
                }}
              />
            </Box>
          </>
        )}
      </Box>
      <PurchaseOrder
        tableData={products}
        productOptionsList={supplierProducts}
        mode={mode}
        selectedSupplierId={formData.supplier}
        additionalCostsData={additionalCosts}
        purchaseOrderId={purchaseOrderItem?.id}
        selectedSupplier={selectedSupplier}
        onAddNewProduct={handleAddNewProduct}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        formData={formData}
        entities={entities}
      />
    </Box>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getSupplierList: (data) => dispatch(getSuppliers(data)),
  createContact: (data) => dispatch(createNewContact(data)),
  createSupplier: (data) => dispatch(createNewSupplier(data)),
  getCurrencies: () => dispatch(getCurrencies()),
  getStatus: () => dispatch(getStatus()),
  getPaymentTerms: () => dispatch(getPaymentTerms()),
  getDefaultCarrier: () => dispatch(getDefaultCarrier()),
  getTaxRule: () => dispatch(getTaxRule()),
  getAllEntities: () => dispatch(getAllEntities()),
  fetchSearchedContacts: (data) => dispatch(fetchSearchedContacts(data)),
});

export default connect(null, mapDispatchToProps)(AddPurchase);
